import {useStyles} from '@wix/tpa-settings/react'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import {DynamicStyle} from '../../../../../../commons/components/dynamic-style'
import {isEditor} from '../../../../../../commons/selectors/environment'
import stylesParams from '../../../../stylesParams'
import {useWidgetState} from '../../../hooks/state-provider'
import {useEventsList} from '../../../hooks/use-events-list'
import {getCompId} from '../../../selectors/component'
import {focusFirstNewEvent} from '../../../utils/a11y'
import {CategoryTabs} from '../../category-tabs'
import {EmptyCategory} from '../../category-tabs/empty-category'
import {LoadMoreButton} from '../../load-more-button'
import {MainListTitle} from '../../main-list-title'
import {OnImageItem} from '../on-image-item'
import s from './on-image-list.scss'

export const OnImageList = () => {
  const {events, hasMore, moreLoading, pageLimit} = useEventsList()
  const {isMobile} = useEnvironment()
  const editor = useWidgetState(isEditor)
  const compId = useWidgetState(getCompId)
  const styles = useStyles()

  const cardsPerRow = styles.get(stylesParams.cardsPerRow)
  const eventsCount = events.length
  const columnCount = Math.min(cardsPerRow, eventsCount, pageLimit)

  useEffect(() => {
    focusFirstNewEvent({eventsCount, pageLimit, hasMore, compId, listItem: false})
  }, [eventsCount])

  return (
    <div className={classNames(s.container, s.border)}>
      {editor && !isMobile && (
        <DynamicStyle namespace={compId}>
          {`.${s.grid} {
          --columns: ${columnCount};
        }`}
        </DynamicStyle>
      )}
      <MainListTitle />
      <CategoryTabs />
      {!events.length ? (
        <EmptyCategory />
      ) : (
        <>
          <ul className={classNames(s.grid, {[s.mobile]: isMobile})}>
            {events.map(event => (
              <OnImageItem key={event.id} event={event} />
            ))}
          </ul>
          {(hasMore || moreLoading) && <LoadMoreButton mobile={isMobile} hasMore={hasMore} moreLoading={moreLoading} />}
        </>
      )}
    </div>
  )
}
